import React from 'react';
import FloatingToolbar from '../ui/FloatingToolbar';
import AdminEditingCaution from '../ui/AdminEditingCaution';
import { BUILD_MANAGEMENT_ENTRY_LABEL } from '../../types/buildManagement';

interface VehicleOwnerToolbarProps {
  onAddModification: () => void;
  onImportModifications: () => void;
  onEnhanceModifications?: () => void;
  onManageBuild: () => void;
  showEnhance?: boolean;
  /** When set, shows a compact Super Admin caution after Manage build. */
  adminEditingOwnerLabel?: string | null;
}

export const VehicleOwnerToolbar: React.FC<VehicleOwnerToolbarProps> = ({
  onAddModification,
  onImportModifications,
  onEnhanceModifications,
  onManageBuild,
  showEnhance = false,
  adminEditingOwnerLabel = null,
}) => (
  <FloatingToolbar
    actions={[
      {
        id: 'add-mod',
        label: 'Add part',
        variant: 'primary',
        onClick: onAddModification,
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        ),
      },
      {
        id: 'import-mods',
        label: 'Import build list',
        title: 'Import build list',
        variant: 'secondary',
        onClick: onImportModifications,
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        ),
      },
      ...(showEnhance && onEnhanceModifications
        ? [
            {
              id: 'enhance-mods',
              label: 'Improve existing parts',
              title: 'Improve existing parts',
              variant: 'secondary' as const,
              onClick: onEnhanceModifications,
              icon: (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                  />
                </svg>
              ),
            },
          ]
        : []),
      {
        id: 'manage-build',
        label: BUILD_MANAGEMENT_ENTRY_LABEL,
        title: BUILD_MANAGEMENT_ENTRY_LABEL,
        variant: 'muted',
        onClick: onManageBuild,
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h10M4 18h7" />
          </svg>
        ),
      },
    ]}
    trailing={
      adminEditingOwnerLabel ? (
        <AdminEditingCaution contentLabel="vehicle" ownerLabel={adminEditingOwnerLabel} />
      ) : null
    }
  />
);
